import type { ChangeEvent, FormEvent } from 'react'
import type { FieldViewProps } from '../../types'
import type BooleanController from './Controller'

import React from 'react'
import { useTranslation } from 'react-i18next'

import { Operators } from '@/shared/components/query-builder'
import { Label } from '@/shared/components/ui/label'
import { Radio } from '@/shared/components/ui/radio'

import { Group } from '../../components/InputGroup'

type Props = FieldViewProps<BooleanController>
export default function BooleanView({
	field,
	invalidMessage,
	isRemovable,
	isDirty,
	localValue,
	onRemove,
	onApply,
	onChange,
	closePopup,
}: Props) {
	const { t } = useTranslation()

	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		if (invalidMessage) return
		onApply?.()
		closePopup?.()
	}
	const onChangeCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value
		onChange({ operation: Operators.BL, value })
	}
	const isInvalid = Boolean(invalidMessage)

	return (
		<Group
			onSubmit={handleSubmit}
			onRemove={isRemovable ? onRemove : undefined}
			isDisabledApply={
				!isDirty || Boolean(isInvalid || field.validate(localValue, t))
			}
		>
			<div className='max-w-[260px] min-w-[260px] space-y-2 p-5'>
				<div className='flex flex-col space-y-3'>
					<div className='flex items-center space-x-2'>
						<Radio
							id='radio-a-0'
							checked={localValue.value == '0'}
							name='value'
							onChange={onChangeCheckbox}
							value='0'
						/>
						<Label htmlFor='radio-a-0'>
							{t('false', { defaultValue: 'False' })}
						</Label>
					</div>
					<div className='flex items-center space-x-2'>
						<Radio
							id='radio-a-1'
							checked={localValue.value == '1'}
							name='value'
							onChange={onChangeCheckbox}
							value='1'
						/>
						<Label htmlFor='adio-a-1'>
							{t('true', { defaultValue: 'True' })}
						</Label>
					</div>
				</div>
				{field.note && (
					<div className='text-sm text-muted-foreground'>{field.note}</div>
				)}
			</div>
		</Group>
	)
}
